import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const SubjectAllocationDeleteDialog = ({ open, onClose, onConfirm, allocation, deleting }) => {
  if (!allocation) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        Confirm Deletion
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this allocation?
        </Typography>
        <Box sx={{ mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
          <Typography variant="body2"><strong>Teacher:</strong> {allocation.teacher?.full_name || "N/A"}</Typography>
          <Typography variant="body2"><strong>Class:</strong> {allocation.class_stream_subject_paper?.class?.name || allocation.class_stream_subject_paper?.class?.class_name || "N/A"}</Typography>
          <Typography variant="body2"><strong>Subject:</strong> {allocation.class_stream_subject_paper?.subject_paper?.subject?.subject_name || "N/A"}</Typography>
          <Typography variant="body2"><strong>Paper:</strong> {allocation.class_stream_subject_paper?.subject_paper?.paper_name || "N/A"}</Typography>
          <Typography variant="body2"><strong>Year:</strong> {allocation.academic_year}</Typography>
          <Typography variant="body2"><strong>Type:</strong> {allocation.is_primary ? "Primary" : "Assistant"}</Typography>
        </Box>
        <Typography variant="body1"  sx={{ mt: 2 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={deleting} startIcon={deleting ? <CircularProgress size={20} /> : null}>
          {deleting ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubjectAllocationDeleteDialog;
